import * as React from 'react';
import { Manager, Reference } from 'react-popper';
import { TooltipContainer } from './components/TooltipContainer.js';
import { TooltipContent } from './components/TooltipContent.js';
import { TooltipMessage } from './components/TooltipMessage.js';
import { TooltipTrigger } from './components/TooltipTrigger.js';

const Tooltip = ({ id , message , className , placement , boundariesElement , label , renderLabel , 'aria-label': ariaLabel , iconName ='info' , theme , preventClickDefault , onClick , renderInPortal  })=>{
    return /*#__PURE__*/ React.createElement(TooltipContainer, {
        className: className,
        theme: theme
    }, /*#__PURE__*/ React.createElement(Manager, null, /*#__PURE__*/ React.createElement(Reference, null, ({ ref  })=>/*#__PURE__*/ React.createElement(TooltipTrigger, {
            "aria-label": ariaLabel,
            ref: ref,
            iconName: iconName,
            renderLabel: renderLabel,
            label: label,
            theme: theme,
            preventClickDefault: preventClickDefault,
            onClick: onClick
        })
    ), /*#__PURE__*/ React.createElement(TooltipContent, {
        id: id,
        placement: placement,
        boundariesElement: boundariesElement,
        theme: theme,
        renderInPortal: renderInPortal
    }, /*#__PURE__*/ React.createElement(TooltipMessage, {
        message: message
    }))));
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
